if (!customElements.get('main-customizer')) {
  class Customizer extends HTMLElement {

    constructor() {
      super();
      this.id = this.getAttribute('id');
      this.form = this.querySelector('[data-product-form]');
      this.handle = this.form.dataset.productHandle;
      this.customId = this.querySelector('[data-customizer-id]');
      this.customGallerySVGs = this.querySelectorAll('[data-customizer-svg]');
      this.productPrice = this.querySelector('[data-product-price]');
      this.comparePrice = this.querySelector('[data-compare-price]');
      this.mainColorSwatch = this.querySelectorAll('[data-main-color]');
      this.mainColorProp = this.querySelector('[data-custom-main-prop]');
      this.tieColorSwatch = this.querySelectorAll('[data-tie-color]');
      this.tieColorProp = this.querySelector('[data-custom-tie-prop]');
      this.knotColorSwatch = this.querySelectorAll('[data-knot-color]');
      this.knotColorProp = this.querySelector('[data-custom-knot-prop]');
      // this.leadTerms = this.querySelector('#customTerms');
      this.refundTerms = this.querySelector('#acceptTerms');
      this.customizerAddToCart = this.querySelector('[data-custom-add-to-cart]');
      this.dialogEntry = document.querySelector('[data-dialog-entry]');
      this.customBraceletRadios = this.querySelectorAll('[data-custom-bracelet]');
      this.customTypeRadios = this.querySelectorAll('[data-custom-type]');
      this.engravingFields = this.querySelector('[data-engraving-fields]');
      this.customizerFields = this.querySelectorAll('[data-customizer-fields]');
      this.engravingFontProp = this.querySelector('[data-engraving-font-prop]');
      this.engravingContentProp = this.querySelector('[data-engraving-content-prop]');
      this.engravingFontBtn = this.querySelectorAll('[data-engraving-font]');
      this.engravingSymbols = this.querySelectorAll('[data-engraving-symbol]');
      this.engravingGreekLetters = this.querySelectorAll('[data-greek-letter]');
      this.engravingInput = this.querySelector('[data-engraving-input]');
      this.metalInputs = this.querySelectorAll('[name="options[Finish]"]');
      this.symbolsDropdownBtns = this.querySelectorAll('[data-toggle-symbols]');
      this.baggieQuantity = this.querySelector('[data-add-on-quantity]');
      this.baggiePriceEl = this.querySelector('[data-add-on-price]');
      this.baggiePrice = this.querySelector('[data-add-on-price]')?.dataset.addOnPrice;
      this.mainColorsArray = [];
      this.tieColorsArray = [];
      this.knotColorArray = [];
      this.mainStringAssets = [];
      this.mainTieAssets = [];
      this.mainKnotAssets = [];
      this.selectedMainColors = { count: 0 };
      this.selectedTiecolors = { count: 0 };
      this.selectedKnotColor = { count: 0 };
      this.minimumSelection = 1;
      this.svgPaths = [
        [
          this.querySelectorAll('path[fill="#FFFFFE"]'),
          this.querySelectorAll('path[fill="#FFFFFD"]'),
          this.querySelectorAll('path[fill="#FFFFFC"]'),
          this.querySelectorAll('path[fill="#FFFEFE"]'),
          this.querySelectorAll('path[fill="#FFFEFD"]'),
          this.querySelectorAll('path[fill="#FFFEFC"]'),
        ],
        [
          this.querySelectorAll('path[fill="#FEFEFF"], circle[fill="#FEFEFF"]'),
          this.querySelectorAll('path[fill="#FEFFFE"], circle[fill="#FEFFFE"]'),
        ],
        [this.querySelectorAll('circle[fill="#FEFEFE"], path[fill="#FEFEFE"]')],
      ];
      this.pCharmSVGPaths = {
        inner: this.querySelectorAll('[data-pcharm-inner]'),
        outer: this.querySelectorAll('[data-pcharm-outer]'),
      };
      this.pCharmColors = {
        Silver: {
          inner: '#e6e6e6',
          outer: '#cdcdcd',
        },
        'Rose Gold': {
          inner: '#E8BC9F',
          outer: '#D0A98F',
        },
        Gold: {
          inner: '#EEE8AA',
          outer: '#d6d099',
        },
      };
      this.mainStringLimit = 3;
      this.engravingContentReset = '';
      this.engravingFontReset = 'lucida-handwriting';
      this.initProductForm();
      this.mainColorSwatch.forEach(input => input.addEventListener('change', this.mainColorChange.bind(this)));
      this.tieColorSwatch.forEach(input => input.addEventListener('change', this.tieColorChange.bind(this)));
      this.knotColorSwatch.forEach(input => input.addEventListener('change', this.knotColorChange.bind(this)));
      this.engravingInput.addEventListener('paste', e => { e.preventDefault() });
      this.symbolsDropdownBtns.forEach(button => button.addEventListener('click', function () { this.classList.toggle('active') }));
      // [this.leadTerms, this.refundTerms].forEach((checkbox) => checkbox.addEventListener('change', this.onTermsChange.bind(this)));
      this.refundTerms.addEventListener('change', this.onTermsChange.bind(this));
      this.engravingGreekLetters.forEach(button => button.addEventListener('click', this.onGreekLetterClick.bind(this)));
      this.customizerAddToCart.addEventListener('click', this.onAddToCartClick.bind(this));
      this.customBraceletRadios.forEach(radio => radio.addEventListener('change', this.onCustomBraceletChange.bind(this)));
      this.customTypeRadios.forEach(radio => radio.addEventListener('click', this.onCustomTypeChange.bind(this)));
      this.engravingFontBtn.forEach(button => button.addEventListener('change', this.onFontChange.bind(this)));
      this.engravingInput.addEventListener('input', this.onEngravingInput.bind(this));
      this.engravingSymbols.forEach(button => button.addEventListener('click', this.onSymbolClick.bind(this)));
      document.addEventListener('click', this.onDocumentClick.bind(this));
      this.initWindowResize();
      this.engravingPopover = this.querySelector('[data-engraving-popover]');
      this.engravingPopoverClose = this.querySelector('[data-engraving-popover-close]');
      this.engravingPopoverClose.addEventListener('click', this.setHidden.bind(this));
      this.engravingPopoverViewed = false;
      this.fomo = this.querySelector('[data-fomo]');
      this.fomoCount = this.querySelector('[data-fomo-count]');
      this.getMonthsOrders();
    }

    async getMonthsOrders() {
      if (!this.id || !this.fomo) return;
      const response = await fetch(`https://puravida.gadget.app/orders-mtd?id=${this.id}`);
      const data = await response.json();
      console.log('data.ok', data);
      if (data.ok) {
        this.fomoCount.textContent = data.count;
        this.fomo.classList.remove('hidden');
      }
    }

    setHidden() {
      sessionStorage.setItem('customizerPopover', 'hidden');
      this.engravingPopover.classList.remove('active');
    }

    initPopoverTimeout() {
      if (this.engravingPopoverViewed) return;
      const popoverStorage = sessionStorage.getItem('customizerPopover');
      if (popoverStorage == 'hidden') return;
      const component = this;
      component.engravingPopover.classList.add('active');
      setTimeout(() => {
        component.setHidden();
      }, 6000);
    }

    updateAfterpay(amount) {
      const afterpayPlacement = document.querySelector('[data-afterpay][data-location="pdp"]');
      if (!afterpayPlacement) return;
      afterpayPlacement.dataset.amount = amount;
    }

    onSymbolClick(event) {
      const character = String.fromCodePoint(event.target.value);
			const currentText = this.engravingInput.value;
			this.engravingInput.value = currentText.concat(character);
			this.triggerEngravingInput(false);
    }

    onEngravingInput(event) {
      engravingInputHandler(event, event.target);
      this.selectionCheck(this.selectedMainColors, this.selectedTiecolors, this.selectedKnotColor, this.customizerAddToCart, event.target);
      this.initPopoverTimeout();
      this.engravingPopoverViewed = true;
    }

    onFontChange(event) {
      const font = event.target.value;
			this.engravingFontProp.value = font;
			this.engravingFontReset = font;
			characterPreview(this.engravingInput.value, font);
      document.querySelectorAll('[data-engraving-preview]').forEach(el => {
        if (el.classList.contains('hidden')) return;
        const previewDiv = el.querySelector('div');
        textFit(previewDiv, {
          alignHoriz: true,
          alignVertWithFlexbox: true
        });
      });
    }

    onCustomTypeChange(event) {
      const type = event.target.dataset.customType;
			const selection = event.target.value;
			this.updateTypeProp(type, selection);
			this.toggleVisibleSVG(selection);
			const limit = selection.includes('Coin') ? 1 : 2;
			this.updateMaxMainStringNumber(limit);
			this.modifyColors(limit, '[data-main-color]:checked', this.selectedMainColors, this.mainColorsArray, this.mainStringAssets, 'main', this.mainColorProp);
			window.shop_api.engraving.limit = selection.includes('Coin') ? 3 : 14;
			this.triggerEngravingInput(true);
			this.selectStyleOption(selection);
    }

    clearEngravingProps() {
      this.engravingFontProp.value = '';
      this.engravingContentProp.value = '';
    }

    updateTypeProp(type, selection) {
      document.querySelector(`[data-type-prop="${type}"]`).value = selection;
    }

    charmChangeHandler(style) {
      const limit = 2;
      this.toggleStyleOptions(style);
      this.modifyColors(limit, '[data-main-color]:checked', this.selectedMainColors, this.mainColorsArray, this.mainStringAssets, 'main', this.mainColorProp);
      this.updateMaxMainStringNumber(limit);
      this.metalInputs.forEach((button) => {
        button.removeAttribute('disabled');
        if (button.value != 'Silver') {
          button.setAttribute('disabled', 'disabled');
        }
      });
    }

    toggleStyleOptions(style) {
      const customGroup = document.querySelector(`[data-customizer-group="${style}"]`);
      // customGroup.style.display = 'block';
      customGroup.removeAttribute('disabled');
      const selection = customGroup.querySelector('[type="radio"]:checked').value;
      this.updateTypeProp(style, selection);
    }

    engravingChangeHandler(style) {
      this.toggleStyleOptions(style);
      this.engravingFields.classList.remove('no-show');
      this.engravingContentProp.value = this.engravingContentReset;
      this.engravingFontProp.value = this.engravingFontReset;
      const selectedType = document.querySelector(`[data-custom-type="${style}"]:checked`).value;
      const limit = selectedType.includes('Bar') ? 2 : 1;
      this.updateMaxMainStringNumber(limit);
      this.modifyColors(limit, '[data-main-color]:checked', this.selectedMainColors, this.mainColorsArray, this.mainStringAssets, 'main', this.mainColorProp);
      this.metalInputs.forEach((button) => {
        button.removeAttribute('disabled');
        if (button.value == 'Gold') {
          button.setAttribute('disabled', 'disabled');
        }
      });
    }

    toggleOptions(style) {
      document.querySelectorAll('[data-type-prop]').forEach((input) => (input.value = ''));
      document.querySelectorAll('[data-customizer-group]').forEach((group) => {
        group.style.display = 'none';
        group.setAttribute('disabled', 'disabled');
      });
      this.engravingFields.classList.add('no-show');
      if (style.includes('Engraving')) {
        this.engravingChangeHandler(style);
      } else if (style.includes('Charm')) {
        this.charmChangeHandler(style);
        this.clearEngravingProps();
      } else {
        const limit = 3;
        this.clearEngravingProps();
        this.updateMaxMainStringNumber(limit);
        this.metalInputs.forEach((button) => button.removeAttribute('disabled'));
      }
    }

    onCustomBraceletChange(event) {
      const type = event.target.value;
      this.selectStyleOption(type);
			// if (type == 'Original' || type == 'Braided') {
			// 	this.selectStyleOption(type);
			// } else {
			// 	const selectedType = document.querySelector(`[data-custom-type="${type}"]:checked`).value;
      //   console.log('selectedType', selectedType);
			// 	this.selectStyleOption(selectedType);
			// }
			this.toggleOptions(type);
    }

    onDocumentClick(event) {
      if (event.target.hasAttribute('data-confirm-custom')) {
        document.querySelector('[data-submit-custom]').click();
        hideDialog();
      } else if (event.target.hasAttribute('data-edit-custom')) {
        hideDialog();
      }
    }

    onAddToCartClick() {
      const container = this;
      const selectedStyle = document.querySelector('[data-custom-bracelet]:checked').value;
      if (selectedStyle == 'Engraving') {
        const lowercaseValue = window.shop_api.engraving.customContent.toLowerCase();
        const additionalProfanityTest = shop_api.settings.customProfanityFilter?.some(value => lowercaseValue.includes(value));
        const url = `https://www.purgomalum.com/service/containsprofanity?text=${window.shop_api.engraving.customContent}`;
        const req = new XMLHttpRequest();
        req.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (JSON.parse(req.responseText) || additionalProfanityTest) {
              const profanityMarkup =
                '<div class="confirm-custom"><div class="confirm-custom__main warning"><h2 class="confirm-custom__title">Oops! We can’t engrave that phrase.</h2><p class="confirm-custom__body">Change it up and try again, or <a href="https://puravidabracelets.kustomer.help/contact/contact-us-jn23-ByJPhOe3i">contact customer service</a> if you have any questions.</p></div></div>';
              container.dialogEntry.innerHTML = profanityMarkup;
              showDialog('engraving-warning-dialog');
            } else {
              container.confirmCustomDialog();
            }
          }
        };
        req.open('GET', url, true);
        req.send(null);
      } else {
        container.confirmCustomDialog();
      }
    }

    confirmCustomDialog() {
      const selectedMetal = document.querySelector('[data-custom-metal]:checked').value;
      const svg = document.querySelector('.product__gallery--customizer').innerHTML;
      const mainColors = `<div class="confirm-colors"><span class="confirm-colors__name">Main strings:</span><span class="confirm-colors__colors">${this.mainColorsArray.join(
        ', '
      )}</span></div>`;
      const tieColors = `<div class="confirm-colors"><span class="confirm-colors__name">Tie colors:</span><span class="confirm-colors__colors">${this.tieColorsArray.join(
        ', '
      )}</span></div>`;
      const knotColor = `<div class="confirm-colors"><span class="confirm-colors__name">Knot color:</span><span class="confirm-colors__colors">${this.knotColorArray.join(
        ', '
      )}</span></div>`;
      const metalColor = `<div class="confirm-colors"><span class="confirm-colors__name">Metal color:</span><span class="confirm-colors__colors">${selectedMetal}</span></div>`;
      const selectedFont = document.querySelector('[data-engraving-font]:checked').value;
      const engravingPreview =
        document.querySelector('[data-custom-bracelet]:checked').value == 'Engraving'
          ? `<div class="confirm-colors"><span class="confirm-colors__name">My engraving:</span><span class="confirm-engraving__text ${selectedFont}">${window.shop_api.engraving.preview}</span></div>`
          : '';
      const customConfirmation = `<div class="confirm-custom">${svg}<div class="confirm-custom__main"><h2 class="confirm-custom__title">HOW’S IT LOOK?!</h2><p class="confirm-custom__body">Make sure we nailed your color combo before placing an order (all sales are final!).</p><div>${mainColors}${tieColors}${knotColor}${metalColor}${engravingPreview}</div><div class="confirm-custom__btns"><button class="button button--black button--small" data-edit-custom type="button">Edit bracelet</button><button class="button button--teal button--small" type="button" data-close-popup data-confirm-custom>Looks great!</button></div></div></div>`;
      this.dialogEntry.innerHTML = customConfirmation;
      showDialog('confirm-custom-dialog');
      setTimeout(() => {
        document.querySelectorAll('.confirm-custom [data-engraving-preview]').forEach(el => {
          if (el.classList.contains('hidden')) return;
          const previewDiv = el.querySelector('div');
          textFit(previewDiv, {
            alignHoriz: true,
            alignVertWithFlexbox: true
          });
        });
      }, 100);
    }

    triggerEngravingInput(toggleEngraving) {
      const event = new CustomEvent('input', {
        detail: {
          triggered: true,
          engravingToggle: toggleEngraving,
        },
      });
      this.engravingInput.dispatchEvent(event);
    }

    onGreekLetterClick(event) {
      const { value } = event.target;
			const currentText = this.engravingInput.value;
			this.engravingInput.value = currentText.concat(value);
			this.triggerEngravingInput(false);
    }

    mainColorChange(event) {
      this.colorChangeHandler(event.target, '[data-main-color]:checked', this.mainStringLimit, this.selectedMainColors, this.mainColorsArray, this.mainStringAssets, 'main', this.mainColorProp);
      this.initPopoverTimeout();
    }

    tieColorChange(event) {
      this.colorChangeHandler(event.target, '[data-tie-color]:checked', 2, this.selectedTiecolors, this.tieColorsArray, this.mainTieAssets, 'tie', this.tieColorProp);
    }

    knotColorChange(event) {
      this.colorChangeHandler(event.target, '[data-knot-color]:checked', 1, this.selectedKnotColor, this.knotColorArray, this.mainKnotAssets, 'knot', this.knotColorProp);
    }

    onTermsChange(event) {
      this.selectionCheck(this.selectedMainColors, this.selectedTiecolors, this.selectedKnotColor, this.customizerAddToCart, this.engravingInput);
    }

    initProductForm() {
      const container = this;

      fetch(`/products/${container.handle}.js`)
        .then((response) => response.json())
        .then((productJSON) => {
          new Shopify.theme.productForm.ProductForm(container.form, productJSON, {
            onOptionChange,
            onQuantityChange,
            onFormSubmit: onFormSubmitCustom,
          });
        });

      const money = (cents) => formatMoney(cents, shop_api.shop.moneyFormat).replace('.00','');
      
      function onQuantityChange(event) {
        const qty = event.dataset.quantity;
        container.selectionCheck(container.selectedMainColors, container.selectedTiecolors, container.selectedKnotColor, container.customizerAddToCart, container.engravingInput);
        const cost = qty * (event.dataset.variant.price / 100);
        container.updateAfterpay(cost);
        if (qty > 2500) {
          container.form.classList.add('quote-needed');
        } else {
          container.form.classList.remove('quote-needed');
          if (!container.baggieQuantity) return;
          container.baggieQuantity.innerText = Number(qty).toLocaleString('en-US');
          container.baggiePriceEl.innerHTML = `<span class="money">$${(qty * parseFloat(container.baggiePrice)).toFixed(2).replace('.00','')}</span>`;
        }
      }

      function onOptionChange(event) {
        const { variant } = event.dataset;
        console.log('variant', variant);
        const style = event.dataset.options.filter((item) => item.name == 'Style')[0].value;
        const metalColor = event.dataset.options.filter((item) => item.name == 'Finish')[0].value;
        if (variant) {
          const price = `${money(variant.price)}/bracelet`;
          const priceInt = variant.price / 100;
          const qty = event.dataset.quantity;
          const cost = qty * priceInt;
          container.updateAfterpay(cost);
          refreshQuantityValues(priceInt);
          container.customId.value = variant.id;
          container.productPrice.innerHTML = price;
          if ((variant.compare_at_price > variant.price) && container.comparePrice) {
            container.comparePrice.innerHTML = money(variant.compare_at_price)
          } else if (container.comparePrice) {
            container.comparePrice.innerHTML = '';
          }
          container.selectionCheck(container.selectedMainColors, container.selectedTiecolors, container.selectedKnotColor, container.customizerAddToCart, container.engravingInput);
          container.customizerAddToCart.value = 'Add to Cart';
          container.customizerFields.forEach((field) => (field.style.display = 'block'));
          if (style.includes('Engraving')) {
            container.engravingFields.style.display = 'block';
          }
        } else {
          container.customizerAddToCart.setAttribute('disabled', 'disabled');
          container.customizerAddToCart.value = 'Metal Color Unavailable';
          container.customizerFields.forEach((field) => (field.style.display = 'none'));
          container.engravingFields.style.display = 'none';
        }
        container.toggleVisibleSVG(style);
        toggleMetalColorChange(metalColor);
      }

      function toggleMetalColorChange(color) {
        ['inner', 'outer'].forEach((location) => {
          container.pCharmSVGPaths[location].forEach(path => {
            path.setAttribute('fill', container.pCharmColors[color][location]);
          });
        });
      }
      
      function refreshQuantityValues(price) {
        document.querySelectorAll('[data-custom-quantity]').forEach((option) => {
          const qty = option.value;
          option.innerHTML = `${Number(qty).toLocaleString('en-US')}&nbsp;&nbsp;&nbsp;&nbsp;$${Number(price * qty).toLocaleString('en-US')}`;
        });
      }
    }

    selectStyleOption(style) {
      document.querySelector(`[name="options[Style]"][value="${style}"]`).click();
    }

    toggleVisibleSVG(style) {
      this.customGallerySVGs.forEach((svg) => {
        svg.classList.add('hidden');
        const svgPreview = svg.querySelector('[data-engraving-preview]');
        if (svgPreview) {
          svgPreview.classList.add('hidden');
        }
      });
      document.querySelector(`[data-customizer-svg="${style}"]`).classList.remove('hidden');
      const currentSVGPreview = document.querySelector(`[data-customizer-svg="${style}"]`).querySelector('[data-engraving-preview]');
      if (currentSVGPreview) {
        currentSVGPreview.classList.remove('hidden');
      }
    }

    colorChangeHandler(input, inputSelector, limit, countVar, colorArray, stringAssets, group, stringProp) {
      const selectedCount = document.querySelectorAll(inputSelector).length;
      if (selectedCount > limit) {
        input.checked = false;
        return;
      }
      if (input.checked) {
        countVar.count += 1;
        colorArray.push(input.value);
        stringAssets.push(input.dataset.stringSrc);
      } else {
        countVar.count -= 1;
        colorArray.splice(colorArray.indexOf(input.value, colorArray), 1);
        stringAssets.splice(stringAssets.indexOf(input.dataset.stringSrc, stringAssets), 1);
      }
      this.setSelectedColors(group, stringAssets);
      this.selectionCheck(this.selectedMainColors, this.selectedTiecolors, this.selectedKnotColor, this.customizerAddToCart, this.engravingInput);
      this.updateSVGPreview();
      this.setCustomPropertyVal(stringProp, colorArray);
    }

    setCustomPropertyVal(prop, array) {
      prop.value = array.join();
    }

    updateSVGPreview() {
      const stringColors = Array.from(document.querySelectorAll('[data-main-color]:checked')).map(
        (input) => input.dataset.color
      );
      const tieColors = Array.from(document.querySelectorAll('[data-tie-color]:checked')).map(
        (input) => input.dataset.color
      );
      const knotColor = Array.from(document.querySelectorAll('[data-knot-color]:checked')).map(
        (input) => input.dataset.color
      );
      this.svgPaths[0].forEach((paths, index) => {
        paths.forEach((path) => path.setAttribute('fill', stringColors[index % stringColors.length] || 'white'));
      });
      this.svgPaths[1].forEach((paths, index) => {
        paths.forEach((path) => path.setAttribute('fill', tieColors[index % tieColors.length] || 'white'));
      });
      this.svgPaths[2].forEach((paths, index) => {
        paths.forEach((path) => path.setAttribute('fill', knotColor[index % knotColor.length] || 'white'));
      });
    }

    setSelectedColors(group, swatchSrc) {
      document
        .querySelectorAll(`[data-selected-swatch-group="${group}"]`)
        .forEach((bubble) => (bubble.style.backgroundImage = 'none'));
      swatchSrc.forEach(
        (src, index) =>
          (document.querySelector(
            `[data-selected-swatch-group="${group}"][data-selected-swatch-${index}]`
          ).style.backgroundImage = `url(${src})`)
      );
    }

    selectionCheck(selectedMainColors, selectedTiecolors, selectedKnotColor, customizerAddToCart, engravingInput) {
      const quantity = document.querySelector('[id="Quantity"]').value;
      const selectedStyle = document.querySelector('[data-custom-bracelet]:checked').value;
      const engravingMin = selectedStyle == 'Engraving' ? 1 : 0;
      if (
        this.refundTerms.checked == true &&
        selectedMainColors.count >= this.minimumSelection &&
        selectedTiecolors.count >= this.minimumSelection &&
        selectedKnotColor.count >= this.minimumSelection &&
        quantity >= 25 &&
        quantity <= 2500 &&
        engravingInput.value.trim().length >= engravingMin
      ) {
        customizerAddToCart.removeAttribute('disabled');
      } else {
        customizerAddToCart.setAttribute('disabled', true);
      }
    }

    modifyColors(allowed, inputSelector, countVar, colorArray, stringAssets, group, stringProp) {
      const selectedCount = document.querySelectorAll(inputSelector).length;
      if ((selectedCount == 3 && allowed == 2) || (selectedCount == 2 && allowed == 1)) {
        const lastColor = colorArray[colorArray.length - 1];
        document.querySelector(`[data-main-color][value="${lastColor}"]`).checked = false;
        countVar.count -= 1;
        colorArray.pop();
        stringAssets.pop();
        this.setSelectedColors(group, stringAssets);
        this.selectionCheck(this.selectedMainColors, this.selectedTiecolors, this.selectedKnotColor, this.customizerAddToCart, this.engravingInput);
        this.updateSVGPreview();
        this.setCustomPropertyVal(stringProp, colorArray);
      }
    }

    updateMaxMainStringNumber(num) {
      this.mainStringLimit = num;
      document.querySelector('[data-max-main-strings]').innerText = num;
      const mobileSelectedColors = document.querySelectorAll('[data-selected-swatch-group="main"]');
      const colorIndexLimit = num - 1;
      mobileSelectedColors.forEach((circle, index) => {
        circle.style.display = 'block';
        if (index > colorIndexLimit) {
          circle.style.display = 'none';
        }
      });
    }

    initWindowResize() {
      window.addEventListener(
        'resize',
        _throttle(() => {
          if (this.engravingInput.value !== '') {
            document.querySelectorAll('[data-engraving-preview]').forEach(el => {
					    if (el.classList.contains('hidden')) return;
              const previewDiv = el.querySelector('div');
              textFit(previewDiv, {
                alignHoriz: true,
                alignVertWithFlexbox: true
              });
            });
          }
        }, 250)
      );
    }

  }
  customElements.define('main-customizer', Customizer);
}